"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Layout_1 = require("./Layout");
var ApplicationError = /** @class */ (function (_super) {
    __extends(ApplicationError, _super);
    function ApplicationError(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            hasError: false, errorMessage: ''
        };
        return _this;
    }
    ApplicationError.getDerivedStateFromError = function (error) {
        return { hasError: true, errorMessage: error.message };
    };
    ApplicationError.prototype.componentDidCatch = function (error, errorInfo) {
        //log error TODO: Create Log Action and Reduer in store
    };
    ApplicationError.prototype.render = function () {
        if (this.state.hasError) {
            return React.createElement(Layout_1.default, null,
                React.createElement("h1", null, "An error has occurred.  The error will be logged. If the issue continues pleace contact your system administrator."));
        }
        return this.props.children;
    };
    return ApplicationError;
}(React.Component));
;
exports.default = (ApplicationError);
//# sourceMappingURL=ApplicationError.js.map